<script setup lang="ts">
import CarwowLogo from './CarwowLogo.vue'
</script>

<template>
  <div class="bx-carwow__presenter">
    Ein Service von
    <CarwowLogo />
  </div>
</template>
